export const PERMISSIONS = {
  project: {
    read: 'projects.read',
    create: 'projects.create',
    readAll: 'projects.readAll'
  },
  projectQuotes: {
    read: 'projectQuotes.read',
    create: 'projectQuotes.create',
    update: 'projectQuotes.update',
    delete: 'projectQuotes.delete',
    readAll: 'projectQuotes.readAll'
  },
  staffQuotes: {
    read: 'staffQuotes.read',
    create: 'staffQuotes.create',
    update: 'staffQuotes.update',
    delete: 'staffQuotes.delete',
    readAll: 'staffQuotes.readAll'
  },
  supportQuotes: {
    read: 'supportQuotes.read',
    create: 'supportQuotes.create',
    update: 'supportQuotes.update',
    delete: 'supportQuotes.delete',
    readAll: 'supportQuotes.readAll'
  },
  rates: {
    read: 'rates.read',
    create: 'rates.create',
    update: 'rates.update',
    delete: 'rates.delete',
    showPrices: 'rates.showPrices'
  },
  users: {
    read: 'users.read',
    update: 'users.update'
  },
  invoiceSwo: {
    read: 'invoiceSwo.read',
    create: 'invoiceSwo.create',
    update: 'invoiceSwo.update',
    delete: 'invoiceSwo.delete',
    markInvoiced: 'invoiceSwo.markInvoiced',
    markPaid: 'invoiceSwo.markPaid'
  },
  invoiceSpwo: {
    read: 'invoiceSpwo.read',
    create: 'invoiceSpwo.create',
    update: 'invoiceSpwo.update',
    delete: 'invoiceSpwo.delete',
    markInvoiced: 'invoiceSpwo.markInvoiced',
    markPaid: 'invoiceSpwo.markPaid'
  },
  invoicePwo: {
    read: 'invoicePwo.read',
    create: 'invoicePwo.create',
    update: 'invoicePwo.update',
    delete: 'invoicePwo.delete',
    markInvoiced: 'invoicePwo.markInvoiced',
    markPaid: 'invoicePwo.markPaid'
  },
  invoiceSwoFiles: {
    read: 'invoiceSwoFiles.read',
    create: 'invoiceSwoFiles.create',
    delete: 'invoiceSwoFiles.delete',
    download: 'invoiceSwoFiles.download'
  },
  invoicePwoFiles: {
    read: 'invoicePwoFiles.read',
    create: 'invoicePwoFiles.create',
    delete: 'invoicePwoFiles.delete',
    download: 'invoicePwoFiles.download'
  },
  deals: {
    read: 'deals.read',
    sendEmail: 'deals.sendEmail'
  }
}
export default PERMISSIONS
